import { ShareType } from "../models/share-type";
import { UserDTO } from "../models/user";

export class AddSharedUserRequest{
    planogramId: string = '';
    stateId: string = '';
    user: UserDTO;
    shareType: ShareType = ShareType.VIEW;
    constructor(planogramId: string, stateId: string, user: UserDTO, shareType: ShareType){
        this.planogramId = planogramId;
        this.stateId = stateId;
        this.user = user;
        this.shareType = shareType;
    }
}

